export const config = {
  baseUrl: 'http://api.portal.lineworker.ru',
  echoApirl: null,
}
